module.exports = __webpack_public_path__ + "admin/img/module_icon_pudu.37de18ec.svg";